module.exports = __webpack_public_path__ + "img/Logo.9a0c8146.svg";